import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.textBackground.light,
    marginBottom: theme.spacing(12),
    padding: theme.spacing(4, 4, 0, 4),
  },
  footerWrapper: {
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
  },
  customFooter: {
    height: theme.spacing(8),
    padding: theme.spacing(1.5, 5),
  },
  container: {
    display: 'flex',
    gap: theme.spacing(4),
  },
  formWidth: { width: '70%' },
  activityLogWidth: { width: '30%' },
  hideActivityLog: {
    display: 'block',
  },
  footerWrapperButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(3),
  },
}))
